import { render, staticRenderFns } from "./portfolioMasonry.vue?vue&type=template&id=a50a701a&"
import script from "./portfolioMasonry.vue?vue&type=script&lang=js&"
export * from "./portfolioMasonry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports